module.exports = __webpack_public_path__ + "img/BGviola2.eddb8298.png";